import { Tour } from "nextstepjs";
import dashboardGuide from "./guides/dashboardGuide";
import manageListGuide from "./guides/manageListGuide";
import flyerGuide from "./guides/flyerGuide";
import recipeListGuide from "./guides/recipeListGuide";
import offersGuide from "./guides/offersGuide";
import recipesGuide from "./guides/recipesGuide";
import searchGuide from "./guides/searchGuide";
import productGuide from "./guides/productGuide";

const mainGuide: Tour[] = [
  ...recipesGuide,
  ...dashboardGuide,
  ...manageListGuide,
  ...flyerGuide,
  ...recipeListGuide,
  ...offersGuide,
  ...searchGuide,
  ...productGuide,
];

export default mainGuide;
